import { configureStore } from '@reduxjs/toolkit';
import { Store } from 'redux';
import ApiClient from '../ApiClient';
import { isClient } from '../utils/util';
import { rootReducer } from './rootReducer';
import { ReduxState } from './types';

let preloadedState = {};
if (isClient()) {
  const serverData = window?.__data__ || {};
  preloadedState = serverData.store || {};
}

export const createStore = (apiClient: ApiClient): Store => {
  return configureStore({
    reducer: rootReducer,
    preloadedState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        thunk: {
          extraArgument: { apiClient: apiClient }
        },
        serializableCheck: false
      })
  });
};

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReduxState;
export type AppDispatch = any;
